const imprint = {
  heading: "Legal Notice",
  subHeading: "Responsible according to § 5 TMG",
  address: {
    name: "Fabian Rapp",
    street: "Carl-Goerdeler Weg 11",
    city: "73079 Süßen"
  },
  email: "fabidevelops@gmail.com"
};

export default imprint;
